import React, { useEffect, useState } from "react";
import { Button, Col, Container, Modal, Row, Spinner, Table } from "react-bootstrap";
import { ShortcutCard } from "../shortcuts/ShortcutCard";
import { obtenerArchivos, descargarArchivo } from "../AccionesBackend";

import iconComisionesVendedores from "../../assets/img/pay.png";
import iconComisionesSupervisores from "../../assets/img/medal.png";
import iconCintasVendedores from "../../assets/img/trophy.png";
import iconCintasSupervisores from "../../assets/img/laurel.png";

const extraerPeriodoDesdeNombre = (nombreArchivo) => {
    nombreArchivo = nombreArchivo.toUpperCase();

    // Eliminar cualquier prefijo numérico no relevante
    nombreArchivo = nombreArchivo.replace(/^\d+_/, '');

    // Expresiones regulares para capturar los periodos
    const patternPuntos = /CALCULO_PUNTOS_SEMANA_(\d+)_([\d]+_AL_[\d]+_[A-Z]+)/i;
    const patternCintas = /CINTAS.*?_(ENERO|FEBRERO|MARZO|ABRIL|MAYO|JUNIO|JULIO|AGOSTO|SEPTIEMBRE|OCTUBRE|NOVIEMBRE|DICIEMBRE)/i;

    // Intentar hacer match con el patrón de puntos
    const matchPuntos = patternPuntos.exec(nombreArchivo);
    if (matchPuntos) {
        return `Semana ${matchPuntos[1]} (${matchPuntos[2]})`;
    }

    // Intentar hacer match con el patrón de cintas
    const matchCintas = patternCintas.exec(nombreArchivo);
    if (matchCintas) {
        return `Mes de ${matchCintas[1].charAt(0).toUpperCase() + matchCintas[1].slice(1).toLowerCase()}`;
    }

    // Si no se encuentra ningún patrón, retornar un mensaje de periodo no identificado
    return "Periodo no identificado";
};
const obtenerPeriodosDesdeExcel = async (archivo, vendedorId, tipo) => {
    try {
        return extraerPeriodoDesdeNombre(archivo.nombre_archivo);
    } catch (error) {
        console.error("Error al leer el archivo Excel:", error);
        return 'Error';
    }
};

const actualizarTablaConPeriodos = async (archivos, vendedorId, tipo) => {
    const archivosConPeriodos = await Promise.all(
        archivos.map(async (archivo) => {
            const periodo = await obtenerPeriodosDesdeExcel(archivo, vendedorId, tipo);
            return { ...archivo, periodo };
        })
    );
    return archivosConPeriodos;
};

const ReportesNew = () => {
    const [rolId, setRolId] = useState(null);
    const [modalShow, setModalShow] = useState(false);
    const [activeShortcut, setActiveShortcut] = useState(null);
    const [pdfs, setPdfs] = useState([]);
    const [iframeLoading, setIframeLoading] = useState(true);
    const [iframeSrc, setIframeSrc] = useState("");

    const shortcuts = [
        {
            title: "Comisiones Vendedores",
            description: "Detalle de comisiones generadas por los vendedores.",
            imgUrl: iconComisionesVendedores,
            backgroundColor: "rgb(236, 105, 7)",
            seccionId: 12,
            rolesAllowed: [1, 2, 3, 4, 5, 13, 14],
        },
        {
            title: "Comisiones Supervisores",
            description: "Comisiones obtenidas por los supervisores sobre las ventas de su equipo.",
            imgUrl: iconComisionesSupervisores,
            backgroundColor: "rgb(215, 0, 109)",
            seccionId: 13,
            rolesAllowed: [1, 2, 3, 4, 13, 14],
        },
        {
            title: "Cintas Vendedores",
            description: "Cintas otorgadas a vendedores por desempeño destacado.",
            imgUrl: iconCintasVendedores,
            backgroundColor: "rgb(0, 188, 180)",
            seccionId: 14,
            rolesAllowed: [1, 2, 3, 4, 5, 13, 14],
        },
        {
            title: "Cintas Supervisores",
            description: "Cintas entregadas a supervisores destacados por liderazgo.",
            imgUrl: iconCintasSupervisores,
            backgroundColor: "rgb(255, 206, 0)",
            seccionId: 15,
            rolesAllowed: [1, 2, 3, 4, 13, 14],
        },
    ];

    useEffect(() => {
        const storedRolId = localStorage.getItem("rol_id");
        if (storedRolId) {
            setRolId(parseInt(storedRolId, 10));
        }
    }, []);

    // Filtrar los accesos (shortcuts) según el rol actual
    const filteredShortcuts = rolId
        ? shortcuts.filter((shortcut) => shortcut.rolesAllowed.includes(rolId))
        : [];

    const handleShortcutClick = (shortcut) => {
        setActiveShortcut(shortcut);
        setModalShow(true);

        obtenerArchivos({ seccionId: shortcut.seccionId })
            .then((result) => {
                if (result && result.success) {
                    actualizarTablaConPeriodos(result.archivos, null, shortcut.title).then(setPdfs);
                } else {
                    console.log(result.mensaje);
                }
            })
            .catch((error) => {
                console.error(error);
            });
    };

    const handleClose = () => {
        setModalShow(false);
        setActiveShortcut(null);
    };

    // Mostrar el iframe de Power BI solo para ciertos roles
    const canViewPowerBI = rolId && [1, 2, 3, 13, 14].includes(rolId);

    useEffect(() => {
        if (canViewPowerBI) {
            const timeout = setTimeout(() => {
                setIframeSrc(
                    "https://app.powerbi.com/view?r=eyJrIjoiOGE3OGZiY2UtZjQxYy00YmZkLWE1OWUtMGYyOTNkZTAxZDExIiwidCI6ImE1MTY5Y2M5LTc1Y2UtNDNmZC1hMTMwLWQ1MjI4MDczZTg3YyIsImMiOjR9"
                );
            }, 1000);
            return () => clearTimeout(timeout);
        }
    }, [canViewPowerBI]);

    return (
        <section className={"reportes-new"}>
            <Container>
                {/* Mostrar el iframe solo si el usuario tiene permisos */}
                {canViewPowerBI && (
                    <>
                        <h1 className="text-center mb-4">Reporte Nacional</h1>
                        {iframeLoading && (
                            <div className="text-center mb-4">
                                <Spinner animation="border" role="status">
                                    <span className="visually-hidden">Cargando...</span>
                                </Spinner>
                            </div>
                        )}
                        {iframeSrc && (
                            <iframe
                                src={iframeSrc}
                                title="Reporte Nacional"
                                style={{ width: "100%", height: "500px", border: "none" }}
                                className="mb-4"
                                onLoad={() => setIframeLoading(false)}
                                onError={() => setIframeLoading(false)}
                            ></iframe>
                        )}
                    </>
                )}
                <h1 className="text-center mb-4">Reportes</h1>
                <Row className="g-4 justify-content-center">
                    {filteredShortcuts.map((shortcut, index) => (
                        <Col key={index} md={3} className="d-flex justify-content-center">
                            <ShortcutCard {...shortcut} onClick={() => handleShortcutClick(shortcut)} />
                        </Col>
                    ))}
                </Row>
                {activeShortcut && (
                    <Modal className="reportes-modal" show={modalShow} onHide={handleClose} centered>
                        <Modal.Header closeButton>
                            <Modal.Title>{activeShortcut.title}</Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <Table responsive={true} striped bordered>
                                <thead>
                                    <tr>
                                        <th>Periodo</th>
                                        <th>Nombre</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {pdfs.map((archivo, index) => (
                                        <tr key={index}>
                                            <td>{archivo.periodo}</td>
                                            <td>{archivo.nombre_archivo}</td>
                                            <td>
                                                <Button
                                                    className="button_id"
                                                    onClick={() =>
                                                        descargarArchivo(activeShortcut.seccionId, archivo.nombre_archivo)
                                                    }
                                                >
                                                    <i className="bi bi-download"></i>
                                                </Button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                        </Modal.Body>
                    </Modal>
                )}
            </Container>
        </section>
    );
};

export { ReportesNew, extraerPeriodoDesdeNombre, obtenerPeriodosDesdeExcel, actualizarTablaConPeriodos };
